import "Lib/tooltipster.bundle.js";

/**
 * This is the code for creating tooltips
 * on pages.
 */
export namespace Tooltips {
	interface IBaseConfig {
		trigger?: string,
		animation?: string,
		maxWidth?: number,
		interactive?: boolean,
		delay?: number,
		side?: string,
		theme?: string,
		contentAsHTML?: boolean
	}

	let initTooltips = () => {
		let $jsTooltip = $('.js-tooltip');
		if(!$jsTooltip.not('.tooltipstered').length) {
			return;
		}
		$jsTooltip.not('.tooltipstered').each(function () {
			let $this = $(this);

			// Each tooltip can have a data-content attribute with the selector of the DOM element that contains the content.
			// If no data-tooltip-content is specified, Tooltips will use the "title" attribute instead
			let $contentTarget = $($this.data('tooltip-content'));
			let overwriteConfig = $this.data('tooltipster') ? $this.data('tooltipster') : {};

			if ($this.attr('title')) {
				$this.attr('data-content', $this.attr('title'));
			} else if ($contentTarget.length) {
				$this.attr('data-content', $contentTarget.text().trim());
			}

			if (!$contentTarget.length && !this.hasAttribute('title')) {
				return;
			}

			let baseConfig:IBaseConfig = {
				trigger: window.matchMedia("(pointer: coarse)").matches ? 'click' : 'hover',
				animation: 'fade',
				maxWidth: 300,
				interactive: true,
				delay: 100,
				side: 'bottom',
				theme: 'tooltipster-borderless',
				contentAsHTML: true
			}

			let config: any = {
				...baseConfig,
				...overwriteConfig
			};

			if ($contentTarget.length) {
				config.content = $contentTarget.html();
				config.contentAsHTML = true;
			}

			($this as any).tooltipster(config);

		});
	};


	/**
	 * Class Method for Rendering Breadcrumbs
	 */
	export const init = () => {
		initTooltips();
	}
}
